import React from 'react';

const PageNotFound = () => {
    return (
        <div >
            <h1 className='text-primary'>Ohoo!<span className='text-danger'> Page Not Founded</span>. Try again...</h1>
            <h1 className='fw-bold'> 404 </h1>
        </div>
    );
};

export default PageNotFound;